module.exports = __webpack_public_path__ + "img/publicBenefit.3fc34006.png";